export default __webpack_public_path__ + "static/media/houimg7.c8559fe5.webp";